import { Injectable, computed, signal } from '@angular/core';
import { DashboardPanel, DashboardResponse, DashboardStatus } from '../models/dashboard.model';

@Injectable({ providedIn: 'root' })
export class DashboardStateService {
  private readonly _panel = signal<DashboardPanel | null>(null);
  private readonly _status = signal<DashboardStatus>('idle');
  private readonly _error = signal<string | null>(null);

  readonly panel = this._panel.asReadonly();
  readonly status = this._status.asReadonly();
  readonly error = this._error.asReadonly();

  readonly isLoading = computed(() => this._status() === 'loading');
  readonly isLoaded = computed(() => this._status() === 'loaded');
  readonly isError = computed(() => this._status() === 'error');

  setLoading(): void {
    this._status.set('loading');
    this._error.set(null);
  }

  setLoaded(response: DashboardResponse): void {
    this._panel.set(response.data);
    this._status.set('loaded');
    this._error.set(null);
  }

  setError(message: string): void {
    this._status.set('error');
    this._error.set(message);
  }

  reset(): void {
    this._panel.set(null);
    this._status.set('idle');
    this._error.set(null);
  }
}
